module.exports = __webpack_public_path__ + "static/media/GAMKONORA_ch4_20210921120834_T.8bb6cd6b.jpg";